export const DATA_TESTID = 'exit-lesson-button'
export const EXIT_LESSON_TEXT = 'EXIT LESSON'
